import { GET_BANK, GET_BANK_SUCCESS, GET_BANK_FAILURE, UPDATE_BANK_STATUS, UPDATE_BANK_STATUS_SUCCESS, UPDATE_BANK_STATUS_FAILURE, DELETE_BANK, DELETE_BANK_SUCCESS, DELETE_BANK_FAILURE, EDIT_BANK, EDIT_BANK_SUCCESS, EDIT_BANK_FAILURE, ADD_BANK, ADD_BANK_SUCCESS, ADD_BANK_FAILURE, COPY_BANK, COPY_BANK_SUCCESS, COPY_BANK_FAILURE } from "../Constants";

const init = {
  data: {},
  delete_data: {},
  edit_data: {},
  add_data: {},
  copy_data: {},
  update_data: {},
};

const BankReducer = (state = init, action) => {
  switch (action.type) {
    case GET_BANK:
      return { ...state, loading: true };
    case GET_BANK_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_BANK_FAILURE:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_BANK_STATUS:
      return { ...state, loading: true };
    case UPDATE_BANK_STATUS_SUCCESS:
      return { ...state, loading: false, update_data: action.payload };
    case UPDATE_BANK_STATUS_FAILURE:
      return { ...state, loading: false, update_data: action.payload };
    case DELETE_BANK:
      return { ...state, loading: true };
    case DELETE_BANK_SUCCESS:
      return { ...state, loading: false, delete_data: action.payload };
    case DELETE_BANK_FAILURE:
      return { ...state, loading: false, delete_data: action.payload };
    case EDIT_BANK:
      return { ...state, loading: true };
    case EDIT_BANK_SUCCESS:
      return { ...state, loading: false, edit_data: action.payload };
    case EDIT_BANK_FAILURE:
      return { ...state, loading: false, edit_data: action.payload };
    case ADD_BANK:
      return { ...state, loading: true };
    case ADD_BANK_SUCCESS:
      return { ...state, loading: false, add_data: action.payload };
    case ADD_BANK_FAILURE:
      return { ...state, loading: false, add_data: action.payload };
    case COPY_BANK:
      return { ...state, loading: true };
    case COPY_BANK_SUCCESS:
      return { ...state, loading: false, add_data: action.payload };
    case COPY_BANK_FAILURE:
      return { ...state, loading: false, add_data: action.payload };
    default:
      return state;
  }
};

export default BankReducer;
